import styled from "styled-components";

export const Buble = styled.div`
  background: #f2f2f2;
  border-radius: 1rem;
  margin: 0.25rem;
  align-self: flex-start;
  overflow: hidden;
  ${({ isme }: { isme?: boolean }) =>
    isme &&
    ` margin-left: auto;
    background-color: #123559;`}
`;
export const TextChat = styled.p`
  margin: 0;
  padding: 0.5rem 1rem;
  word-wrap: break-word;
  ${({ isme }: { isme?: boolean }) => isme && `color: white;`}
`;
export const ImageChat = styled.img`
  width: 256px;
  height: auto;
  border-radius: 1rem;
  cursor: pointer;
`;
export const ContainerBuble = styled.div`
  display: flex;
  width: 100%;
  ${({ isme }: { isme?: boolean }) => isme && "justify-content: flex-end;"}
  padding-bottom: 0;
  transition: all 0.5s ease;
  &:hover {
    transition: all 0.5s ease;
    padding-bottom: 1.5rem;
  }
`;
export const ImageAvatar = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 9999px;
  margin-top: 0.25rem;
  cursor: pointer;
`;

export const TooltipContainer = styled.div`
  position: relative;
  width: 300px;
`;
export const TooltipBox = styled.div`
  z-index: 0;
  position: absolute;
  color: #777;
  padding: 5px;
  border-radius: 5px;
  bottom: 0;
  display: none;
  width: 120px;
  font-size: 0.6rem;
  ${({ show }: { show?: boolean; isme?: boolean }) => show && "display: block;"}
  ${({ isme }: { show?: boolean; isme?: boolean }) => !isme && "right: 0;"}
`;

export const ContainerMetting = styled.div`
  width: 256px;
  height: 256px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #02c92d; /* fallback for old browsers */
`;

export const ButtonLink = styled.a`
  text-decoration: none;
  padding: 0.5rem 1.5rem;
  margin: 1rem;
  background-color: white;
  color: #02c92d;
  border-radius: 999px;
  &:hover {
    color: #02c92d;
  }
`;

export const NewCaseText = styled.p`
  color: #777;
  font-size: 0.75rem;
  text-align: center;
`;
